import clsx from "clsx"
import React from "react"

type Props = {
  className?: string
}

const ItemList: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  React.Children.forEach(children, child => {
    // @ts-expect-error displayName exists
    const displayName = child?.type?.displayName

    if (child && displayName !== "ItemRow")
      throw new Error(
        "Invalid child supplied to `ItemList`. Children should be of type `ItemRow`."
      )
  })

  return (
    <div
      className={clsx(
        className,
        "rounded-xl border border-surface-200 bg-white py-1"
      )}
    >
      {React.Children.map(children, (child, index) => {
        if (!child) return null

        const isLastElement = Array.isArray(children)
          ? children.length - 1 === index
          : true

        // @ts-expect-error can't type this
        return React.cloneElement(child, {
          padding: 0,
          border: 0,
          // @ts-expect-error can't type this
          className: clsx(child.props.className, "rounded-b-none px-2 py-1.5", {
            "border-b border-surface-200": !isLastElement,
          }),
        })
      })}
    </div>
  )
}

export default ItemList
